var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlPaypalFilled = function SvgHtlPaypalFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.626 8.443h1.086c2.36 0 3.7-1.063 4.125-3.247.014-.072.026-.141.037-.211.022-.135.035-.272.041-.41 0-.087.007-.138.006-.187a1.73 1.73 0 0 0-.141-.68 2.34 2.34 0 0 0-.4-.6 3.542 3.542 0 0 0-2.694-1h-3.7a.53.53 0 0 0-.523.447l-.668 4.3-.831 5.359a.319.319 0 0 0 .314.367h1.815l.556-3.3a.989.989 0 0 1 .98-.838h-.003Zm5.96-3c-.519 2.469-2.2 3.779-4.874 3.779H6.626a.217.217 0 0 0-.215.185l-.72 4.485h1.9a.463.463 0 0 0 .458-.391l.019-.1.363-2.3.024-.127a.463.463 0 0 1 .458-.391h.288a3.4 3.4 0 0 0 3.754-2.95 2.532 2.532 0 0 0-.368-2.195l-.001.005Z"
  })));
};
export default SvgHtlPaypalFilled;